<template>
  <div class="modal">
    <v-snackbar v-model="snackbar" timeout="3000"
      >Aktion erfolgreich ausgeführt.
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        scrollable
        :fullscreen="$vuetify.breakpoint.xs ? true : false"
        :transition="
          $vuetify.breakpoint.xs
            ? 'dialog-bottom-transition'
            : 'dialog-transition'
        "
      >
        <v-card :disabled="loading">
          <v-card-title>
            <span class="headline">Verlängerung planen</span>
          </v-card-title>
          <v-card-text v-if="!showSuccess">
            <div class="body-2">
              Ein Verlängerungstermin für diese Frist kann bspw. ein
              Untersuchungstermin, ein Kontrolltermin oder eine Überprüfung
              sein.
            </div>
            <v-spacer style="height: 20px"></v-spacer>
            <v-form v-model="formIsValid" @submit.prevent>
              <v-card outlined>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="scheduledRenewalUpdate.date"
                        type="date"
                        outlined
                        hide-details="auto"
                        label="Datum"
                        :rules="[rules.required]"
                        class="mb-2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="scheduledRenewalUpdate.time"
                        type="time"
                        outlined
                        hide-details="auto"
                        label="Uhrzeit"
                        :rules="[rules.required]"
                        class="mb-2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model.trim="scheduledRenewalUpdate.location"
                        outlined
                        hide-details="auto"
                        clearable
                        :rules="[rules.required]"
                        label="Ort"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model.trim="scheduledRenewalUpdate.note"
                        outlined
                        hide-details="auto"
                        clearable
                        label="Bemerkungen"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider v-if="!hideNotifyUserOption"></v-divider>
                <v-card-text v-if="!hideNotifyUserOption">
                  <v-checkbox
                    v-model="scheduledRenewalUpdate.notifyUser"
                    hide-details="auto"
                    label="Benachrichtigung per E-Mail senden"
                    class="mt-0"
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-form>
          </v-card-text>
          <v-card-text v-if="errorMessage !== ''">
            <v-alert dense text type="error"> {{ errorMessage }} </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$emit('close')">Abbrechen</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              :loading="loading"
              depressed
              color="primary"
              @click="scheduleRenewal()"
            >
              Bestätigen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { functions, Timestamp } from "@/firebase";
export default {
  name: "deadline-entry-renewal-dialog",
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
    hideNotifyUserOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Ist erforderlich.",
      },
      licenseKey: "",
      formIsValid: false,
      loading: false,
      showSuccess: false,
      errorMessage: "",
      dialog: true,
      snackbar: false,

      scheduledRenewalUpdate: {
        date: "",
        time: "",
        location: "",
        note: "",
        notifyUser: true,
      },
    };
  },
  methods: {
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
    scheduleRenewal() {
      this.loading = true;
      this.errorMessage = "";

      const scheduledRenewalObject = {
        timestamp: this.convertToTimestamp(
          this.scheduledRenewalUpdate.date,
          this.scheduledRenewalUpdate.time
        ),
        location: this.scheduledRenewalUpdate.location,
        note: this.scheduledRenewalUpdate.note,
      };
      console.log("Scheduled Renewal Object:", scheduledRenewalObject);

      const callFunction = functions.httpsCallable(
        "memberManagement-scheduleDeadlineEntryRenewals"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadlineEntry.deadline.id,
        deadlineEntryIds: [this.deadlineEntry?.meta?.id],
        scheduledRenewal: {
          ...scheduledRenewalObject,
        },
        notifyUser: this.scheduledRenewalUpdate.notifyUser,
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.showSuccess = true;
            this.snackbar = true;
            this.loading = false;
            this.$emit("close");
          } else {
            this.errorMessage = "Unbekannter Fehler aufgetreten.";
            this.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          this.errorMessage = error.message;
          this.loading = false;
        });
    },
  },
};
</script>
